import { useLocation } from 'react-router-dom';
import { appRoutes } from '../path';

export const useCurrentUrl = () => {
  const { pathname } = useLocation();

  const isDashboardInUrl = pathname.startsWith(appRoutes.dashboard.routePrefix);
  const isWorkspacesInUrl = pathname.startsWith(
    appRoutes.workspaces.routePrefix,
  );
  const isReportInUrl = pathname.startsWith(appRoutes.report.routePrefix);
  const isCohortsInUrl = pathname.startsWith(appRoutes.cohorts.routePrefix);
  const isCreateCohortInUrl = pathname.startsWith(appRoutes.cohorts.create);
  const isViewCohortInUrl = pathname.startsWith(appRoutes.cohorts.view);
  const isSettingsInUrl = pathname.startsWith(appRoutes.settings.routePrefix);
  const isIncidentsInUrl = pathname.startsWith(appRoutes.incidents.routePrefix);
  const isDictionaryInUrl = pathname.startsWith(
    appRoutes.dictionary.routePrefix,
  );
  const isScheduleInUrl = pathname.startsWith(appRoutes.schedules.routePrefix);
  const isScheduleReportInUrl = pathname.startsWith(appRoutes.schedules.report);
  const isAdminInUrl = pathname.startsWith(appRoutes.permission.routePrefix);
  const isDataModelerInUrl = pathname.startsWith(appRoutes.modeler.routePrefix);
  const isDebugInUrl = pathname.startsWith(appRoutes.debug);

  return {
    isDashboardInUrl,
    isWorkspacesInUrl,
    isReportInUrl,
    isCohortsInUrl,
    isSettingsInUrl,
    isIncidentsInUrl,
    isDictionaryInUrl,
    isScheduleInUrl,
    isScheduleReportInUrl,
    isAdminInUrl,
    isDataModelerInUrl,
    isCreateCohortInUrl,
    isViewCohortInUrl,
    isDebugInUrl,
  };
};
